<template>
 <!-- Main content -->
 <section class="content">
   <div>
     <b-alert variant="danger"
            dismissible
            :show="showDismissibleAlert"
            @dismissed="showDismissibleAlert=false">
     {{messageAlert}}
   </b-alert>
   </div>
   <!-- Main row -->
   <div class="row">
     <div class="col-md-12 col-sm-12 col-xs-12">
       <h3>Turno atual <small>{{turnoAtual.nometurno}} das {{turnoAtual.horainicio}} às {{turnoAtual.horafim}} com tempo útil de {{turnoAtual.tempoutil}}h</small></h3>
     </div>
   </div>
   <div class="row" v-if="!detalhar">
     <div class='box'>
       <div class='box-body'>
         <div class='row'>
           <div class='col-md-4' v-for="monitor in monitores" :key="monitor.id">
            <h4 v-if="monitor.atualizado === dia">{{monitor.nomemaquina}} - Uso (%)</h4>
            <h4 v-else>{{buscarMonitorAtual()}}Atualizar Página para - {{dia}}</h4>
            <h5>Velocidade: {{monitor.velocidade}} (cx/h)</h5>
            <va-chart :chart-config='monitor.chartConfig'></va-chart>
           </div>
         </div>
       </div>
     </div>
   </div>
   <div class="row" v-if="!detalhar">
     <div class='box-body'>
       <div class='row'>
         <div class='col-md-4' v-for="monitor in monitores" :key="monitor.id">
           <div class="box box-success">
             <div class="box-header with-border">
               <h4 class="box-title">{{monitor.nomemaquina}} - Produção</h4>
               <div class="box-tools pull-right">
                 <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                 </button>
               </div>
               <!-- /.box-tools -->
             </div>
             <!-- /.box-header -->
             <div class="box-body">
               <table class="table table-condensed">
                <tr>
                  <th>Tag/Cód</th>
                  <th>Duração</th>
                  <th>Operando</th>
                  <th style="width: 80px">Qtd</th>
                  <th style="width: 40px">Perdas</th>
                </tr>
                <tr v-for="(extra, index) in monitor.extraNovo" :key="extra.id">
                  <td>{{index}}</td>
                  <td>{{SegToMili(extra.duracao) }}</td>
                  <td>{{SegToMili(extra.durOperando) }}</td>
                  <td><span class="badge bg-green">{{extra.total}}</span></td>
                  <td><span class="badge bg-red">{{extra.perdas}}</span></td>
                </tr>
              </table>
             </div>
             <!-- /.box-body -->
           </div>
           <!-- /.box -->
         </div>
       </div>
     </div>
   </div>
   <div class="row">
     <div class="col-md-4" v-for="monitor in monitores" :key="monitor.id" v-on:click="detalharMaquina(monitor.idcontrolador, monitor.nomemaquina, monitor.Acionamentos)">
       <!-- small box -->
       <div class="small-box bg-yellow" v-if="monitor.valorfuncao !== 0">
         <div class="inner">
           <span class="info-box-number" v-if="!detalhar">{{monitor.textofuncao}}</span>
           <p>Ordem - {{monitor.tag}}</p>
           <p>{{monitor.nomemaquina}}</p>
           <span class="info-box-text" v-if="!detalhar"><small>{{ajustarData(monitor.updated_at)}}</small></span>
           <div v-if="detalhar">
             <p>Operando: {{monitor.horasoperando}}</p>
             <p>Em Função: {{monitor.horasfuncao}}</p>
             <p>Parado s/ Ordem: {{monitor.horasDisponivelSemOrdem}}</p>
             <p>Parado c/ Ordem: {{monitor.horasDisponivelComOrdem}}</p>
             <p>Disponível: {{monitor.horasdisponivel}}</p>
           </div>
         </div>
         <div class="icon">
           <i class="fa fa-exclamation-triangle"></i>
         </div>
         <div class="small-box-footer" v-if="!detalhar">
           Mais informações <i class="fa fa-arrow-circle-right"></i>
         </div>
       </div>
       <div class="small-box bg-green" v-else-if="monitor.isoperando !== 0">
         <div class="inner">
           <span class="info-box-number" v-if="!detalhar">{{monitor.textostatus}}</span>
           <p>Ordem - {{monitor.tag}}</p>
           <p>{{monitor.nomemaquina}}</p>
           <span class="info-box-text" v-if="!detalhar"><small>{{ajustarData(monitor.updated_at)}}</small></span>
           <div v-if="detalhar">
             <p>Operando: {{monitor.horasoperando}}</p>
             <p>Em Função: {{monitor.horasfuncao}}</p>
             <p>Parado s/ Ordem: {{monitor.horasDisponivelSemOrdem}}</p>
             <p>Parado c/ Ordem: {{monitor.horasDisponivelComOrdem}}</p>
             <p>Disponível: {{monitor.horasdisponivel}}</p>
           </div>
         </div>
         <div class="icon">
           <i class="fa fa-industry"></i>
         </div>
         <div class="small-box-footer" v-if="!detalhar">
           Mais informações <i class="fa fa-arrow-circle-right"></i>
         </div>
       </div>
       <div class="small-box bg-aqua" v-else>
         <div class="inner">
           <span class="info-box-number" v-if="!detalhar">{{monitor.textostatus}}</span>
           <p>Ordem - {{monitor.tag}}</p>
           <p>{{monitor.nomemaquina}}</p>
           <span class="info-box-text" v-if="!detalhar"><small>{{ajustarData(monitor.updated_at)}}</small></span>
           <div v-if="detalhar">
             <p>Operando: {{monitor.horasoperando}}</p>
             <p>Em Função: {{monitor.horasfuncao}}</p>
             <p>Parado s/ Ordem: {{monitor.horasDisponivelSemOrdem}}</p>
             <p>Parado c/ Ordem: {{monitor.horasDisponivelComOrdem}}</p>
             <p>Disponível: {{monitor.horasdisponivel}}</p>
           </div>
         </div>
         <div class="icon">
           <i class="fa fa-hourglass-start"></i>
         </div>
         <div class="small-box-footer" v-if="!detalhar">
           Mais informações <i class="fa fa-arrow-circle-right"></i>
         </div>
       </div>
     </div>
     <!-- ./col -->
   </div>
   <!-- /.row -->
   <div class="row center-block">
     <div class="col-md-12 col-sm-12 col-xs-12">
       <div class="col-sm-1" v-show="detalhar">
         <button type="button" v-on:click="detalhar = false" class="btn">Voltar</button>
       </div>
     </div>
   </div>
   <div class="row center-block" v-if="detalhar">
     <h2>Registros da Máquina</h2>
     <div class="col-md-12">
       <div class="box">
         <div class="box-header">
           <h3 class="box-title">{{detalhes.texto}}</h3>
         </div>
         <!-- /.box-header -->
         <div class="box-body">
           <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
             <div class="row">
               <div class="col-sm-6">
                 <div id="example1_length" class="dataTables_length">
                 </div>
               </div>
             </div>
             <div class="row">
               <div class="col-sm-12 table-responsive">
                 <paginate name="dados" :list="dados" :per="5" class="paginate-list">
                   <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                     <thead>
                       <tr role="row">
                         <th>Data Inicio</th>
                         <th>Data Fim</th>
                         <th>Legenda</th>
                         <th>TAG/Cód</th>
                         <th>Extra</th>
                         <th>Ação</th>
                       </tr>
                     </thead>
                     <tbody>
                       <tr class="even" role="row" v-for="detalhe in paginated('dados')" :key="detalhe.id">
                         <td>{{detalhe.created_at}}</td>
                         <td>{{detalhe.updated_at}}</td>
                         <td>{{detalhe.textolegenda}}</td>
                         <td>{{detalhe.tag}}</td>
                         <td>{{detalhe.extra}}</td>
                         <td>
                           <div>
                             <span class="badge bg-aqua" v-if="detalhe.isinicial === 1">Iniciado</span>
                             <span class="badge bg-yellow" v-else-if="detalhe.isfuncao === 1">Função</span>
                             <span class="badge bg-green" v-else-if="detalhe.isoperando === 1">Operando</span>
                             <span class="badge bg-aqua" v-else>Sem Produção</span>
                           </div>
                         </td>
                       </tr>
                     </tbody>
                   </table>
                 </paginate>
               </div>
             </div>
             <div class="row">
               <div class="col-sm-12 table-responsive">
                 <paginate-links for="dados" :limit="5" :show-step-links="true" id="paginacao"></paginate-links>
               </div>
             </div>
           </div>
           <!-- /.box-body -->
         </div>
       </div>
     </div>
   </div>
 </section>
 <!-- /.content -->
</template>

<script>
import config from '../../config'
import VAChart from '../widgets/VAChart'
import {db} from '../../helpers/firebaseApp'

// console.log('#')
// var caminhoMonitoramento = 'sd222021/monitores'
var data = new Date()
var minutos = data.getMinutes()
if (minutos < 10) {
  minutos = '0' + minutos
}
export default {
  components: {
    'va-chart': VAChart
  },
  data () {
    return {
      dia: (data.getFullYear() + '-' + (this.adicionaZero(data.getMonth() + 1)) + '-' + this.adicionaZero(data.getDate())),
      hora: data.getHours(),
      min: minutos,
      detalhes: {
        idDetalhe: 0,
        texto: ''
      },
      paginate: ['dados'],
      dados: [],
      monitores: [],
      monitoresFirebase: null,
      errors: [],
      detalhar: false,
      showDismissibleAlert: false,
      messageAlert: '',
      deuErro: false
    }
  },
  mounted() {
    if (window.localStorage.getItem('token')) {
      this.buscarTurnoAtual()
      this.buscarMonitorAtual()
    } else {
      this.showDismissibleAlert = true
      this.messageAlert = 'Favor efetuar o login para visualizar os dados'
      this.deuErro = true
    }
  },
  computed: {
    horaAtual() {
      let minutosAgora = data.getMinutes()
      if (minutosAgora < 10) {
        minutosAgora = '0' + minutosAgora
      }
      return minutosAgora
    },
    turnoAtual() {
      return this.$store.state.Turnos.atual
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  firebase: {
    monitores: db.ref('monitores').child(config.project)
  },
  methods: {
    SegToMili: function(temposegundos) {
      return this.$moment.utc(temposegundos * 1000).format('HH:mm:ss')
    },
    ajustarData: function(data) {
      var dataAjustada = new Date(data)
      return dataAjustada.toLocaleString()
    },
    adicionaZero: function(numero) {
      if (numero <= 9) {
        return '0' + numero
      } else {
        return numero
      }
    },
    buscarMonitorAtual: function() {
      this.$store.dispatch('updateMonitorDia')
    },
    buscarTurnoAtual: function() {
      this.$store.dispatch('turnoAtual').catch((err) => {
        if (!this.deuErro && err.response && err.response.status === 401) {
          this.showDismissibleAlert = true
          this.messageAlert = 'Favor efetuar o login para visualizar os dados'
          this.deuErro = true
        } else if (!this.deuErro && err.response && err.response.status === 404) {
          this.showDismissibleAlert = true
          this.messageAlert = 'Empresa não possui turnos cadastrados nesse horário, favor criar para que possam ser exibidos os dados corretamente'
          this.deuErro = true
        } else if (!this.deuErro && err.response && err.response.status === 405) {
          this.showDismissibleAlert = true
          this.messageAlert = 'Favor contatar o administrador do sistema e informar erro 405 ao buscar o turno atual!'
          this.deuErro = true
        }
      })
    },
    detalharMaquina: function(id, txt, acionamentos) {
      if (id !== this.detalhes.idDetalhe) {
        this.detalhar = true
        this.detalhes.idDetalhe = id
      } else {
        this.detalhar = false
      }
      if (!this.detalhar) {
        this.detalhes.idDetalhe = 0
      } else {
        this.detalhes.texto = txt
        this.dados = acionamentos
      }
    }
  }
}
</script>
<style>
@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
 font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
 content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
 content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
 content: "\f0de";
}

.info-box {
 cursor: pointer;
}
.info-box-content {
 text-align: center;
 vertical-align: middle;
 display: inherit;
}
.fullCanvas {
 width: 100%;
}

a {
 cursor: pointer;
}

#paginacao > li {
 display: inline-block;
 margin: 0 10px;
 text-align: center;
}

#paginacao > li.active a {
 font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?4a6fd87d